import { useFormContext } from 'react-hook-form/dist/index.ie11';
import {
  defaultFormValues,
  IMealCreditFormFields,
  transformToYesOrNoOrOptionalString,
  transformToYesOrNoString,
} from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';
import { AvailableOrderTypes } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseMealCreditsDetailsPage.utils';
import { CorpUIResponse } from 'src/types/Corp';
import {
  transformPayloadToFormMerchantRestrictions,
  transformPayloadToFormItemRestrictions,
} from 'src/common/OrderRestrictions/orderRestrictions.utils';

export interface UseInitializeForm {
  initForm: (corpData: CorpUIResponse) => void;
}

export const useInitializeForm = (): UseInitializeForm => {
  const { reset } = useFormContext<IMealCreditFormFields>();

  function initForm(corpData: CorpUIResponse): void {
    // set expense reasons value to default value from corp
    const areExpenseReasonsRequiredForCorp =
      corpData?.predefinedReasonsEnabled && corpData?.predefinedReasonsRequired;

    const areGroupOrdersEnabled = !!corpData?.groupOrderEnabled;

    reset({
      ...defaultFormValues,
      // (WDA-18291) Makes expense codes default to corp level attributes values,
      expenseCodes: transformToYesOrNoOrOptionalString(
        corpData?.expenseCodesRequired,
        corpData?.expenseCodesEnabled
      ),
      ...(areGroupOrdersEnabled && {
        availableOrderTypes: [
          ...defaultFormValues.availableOrderTypes,
          AvailableOrderTypes.GROUP,
        ],
      }),
      expenseReason: transformToYesOrNoString(areExpenseReasonsRequiredForCorp),
      merchantRestrictions: transformPayloadToFormMerchantRestrictions(
        corpData?.defaultMerchantRestrictions
      ),
      itemRestrictions: transformPayloadToFormItemRestrictions(
        corpData?.defaultItemRestrictions
      ),
    });
  }

  return {
    initForm,
  };
};
